import Select from "react-select";

interface ReactSelectProps {
    options: any[];
    value?: any[];
    defaultValue?: any[];
    onChange: (parameter: any[]) => void;
    isMulti?: boolean;
    closeMenuOnSelect?: boolean;
    placeholder?: string;
    noOptionsMessage?: string;
    isDisabled?: boolean;
}

const ReactSelectComponent = ({
    options,
    value,
    defaultValue,
    onChange,
    isMulti = false,
    closeMenuOnSelect = true,
    placeholder = '',
    noOptionsMessage = 'Không có dữ liệu',
    isDisabled = false
}: ReactSelectProps) => {
    return (
        <div>
            <Select
                options={options}
                value={value}
                defaultValue={defaultValue}
                isDisabled={isDisabled}
                onChange={(selected: any) => onChange(selected)}
                isMulti={isMulti}
                closeMenuOnSelect={closeMenuOnSelect}
                placeholder={placeholder}
                noOptionsMessage={() => noOptionsMessage}
            />
        </div>
    );
};

export default ReactSelectComponent;